export default __webpack_public_path__ + "static/brand-efcd1d2377d6eaf09d3c2ccbed5ee4c9.png";